



























export default {
    name: "CollapsiblePanel",
    props: {
        defaultCollapsed: {
            type: Boolean,
            default: true,
        },
    },
    inject: {
        onSelect: { default: null },
    },
    data() {
        return {
            collapsed: true,
            panelClass: "panel-default",
        };
    },
    computed: {
        hasFooterSlot() {
            return !!this.$slots.footer;
        },
    },
    methods: {
        toggleCollapse() {
            this.collapsed = !this.collapsed;
        },
    },
    watch: {
        defaultCollapsed: {
            immediate: true,
            handler(val) {
                this.collapsed = val;
            },
        },
        collapsed: {
            immediate: true,
            handler(val) {
                if (_.isFunction(this.onSelect) && !val) {
                    this.onSelect(this);
                }
                if (val) {
                    this.panelClass = "panel-default";
                }
            },
        },
    },
};
